<div class="modal-header">
    <h4 class="modal-title">Opgaver</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">

    <h5>Mine opgaver ({{ tasksMine30 }} < 30 dage)</h5>
    <div class="table-responsive">
        <table *ngIf="tasksViewMine?.length > 0; else mineZero" class="table table-hover table-striped table-sm">
            <thead>
                <th scope="col"></th>
                <th scope="col">Kundenr.</th>
                <th scope="col">Navn</th>
                <th scope="col">Opgaveopretter</th>
                <th scope="col">Opgave</th>
                <th scope="col" class="text-end">Deadline</th>
            </thead>
            <tbody>
                <tr *ngFor="let samtalelog of tasksViewMine" class="task">
                    <td class="task__status" [ngClass]="statusClass(samtalelog)"></td>
                    <td><span class="clickable--link" (click)="onClientClick(samtalelog.kid)">{{samtalelog.clientId}}</span></td>
                    <td><span class=" clickable--link" (click)="onClientClick(samtalelog.kid)">{{samtalelog.clientName}}</span></td>
                    <td>{{samtalelog.midName}}</td>
                    <td><span class=" clickable--link" (click)="onTaskClick(samtalelog.lid)">{{samtalelog.tekst}}</span></td>
                    <td class="text-nowrap text-end task__functions">
                        <span class="task__functions--no-hover">
                            {{samtalelog.deadline | date:'dd-MM-yyyy'}}
                        </span>
                        <span class="task__functions--hover">
                            <div *ngIf="canDelete(samtalelog)" class="me-2">
                                <i (click)="onDelete(samtalelog.lid)" class="fa fa-trash text-danger clickable--link"></i>
                            </div>
                            <div class="me-2">
                                <i (click)="onReject(samtalelog.lid)" class="fa fa-ban text-danger clickable--link"></i>
                            </div>
                            <div class="me-2">
                                <i (click)="onDone(samtalelog.lid)" class="fa fa-check text-success clickable--link"></i>
                            </div>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <ng-template #mineZero>
            <div class="mb-2">
                Ingen igangværende opgaver.
            </div>
        </ng-template>
    </div>

    <div class="row clickable" (click)="noAssignee = !noAssignee">
        <h5 class="col-10 float-start">Mangler opgaveløser ({{ tasksNoAssignee30 }} < 30 dage)</h5>
        <h5 class="col-2"><i class="float-end pe-2" [ngClass]="noAssignee ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i></h5>
    </div>
    <div *ngIf="noAssignee" class="table-responsive">
        <table *ngIf="tasksViewNoAssignee?.length; else noAssigneeZero" class="table table-hover table-striped table-sm">
            <thead>
                <th scope="col"></th>
                <th scope="col">Kundenr.</th>
                <th scope="col">Navn</th>
                <th scope="col">Opgave</th>
                <th scope="col" class="text-end">Deadline</th>
            </thead>
            <tbody>
                <tr *ngFor="let samtalelog of tasksViewNoAssignee" class="task">
                    <td class="task__status" [ngClass]="statusClass(samtalelog)"></td>
                    <td><span class="clickable--link" (click)="onClientClick(samtalelog.kid)">{{samtalelog.clientId}}</span></td>
                    <td><span class=" clickable--link" (click)="onClientClick(samtalelog.kid)">{{samtalelog.clientName}}</span></td>
                    <td><span class=" clickable--link" (click)="onTaskClick(samtalelog.lid)">{{samtalelog.tekst}}</span></td>
                    <td class="text-nowrap text-end task__functions">
                        <span class="task__functions--no-hover">
                            {{samtalelog.deadline | date:'dd-MM-yyyy'}}
                        </span>
                        <span class="task__functions--hover">
                            <div class="me-2">
                                <i (click)="onDelete(samtalelog.lid)" class="fa fa-trash text-danger clickable--link"></i>
                            </div>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <ng-template #noAssigneeZero>
            <div class="mb-2">
                Der er ingen opgaver, der mangler opgaveløser.
            </div>
        </ng-template>
    </div>

    <div class="row clickable" (click)="delegated = !delegated">
        <h5 class="col-10 float-start">Uddelegerede opgaver ({{ tasksDelegated30 }} < 30 dage)</h5>
        <h5 class="col-2"><i class="float-end pe-2" [ngClass]="delegated ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i></h5>
    </div>
    <div *ngIf="delegated" class="table-responsive">
        <table *ngIf="tasksViewDelegated?.length; else delegatedZero" class="table table-hover table-striped table-sm">
            <thead>
                <th scope="col"></th>
                <th scope="col">Kundenr.</th>
                <th scope="col">Navn</th>
                <th scope="col">Opgaveløser</th>
                <th scope="col">Opgave</th>
                <th scope="col" class="text-end">Deadline</th>
            </thead>
            <tbody>
                <tr *ngFor="let samtalelog of tasksViewDelegated" class="task">
                    <td class="task__status" [ngClass]="statusClass(samtalelog)"></td>
                    <td><span class="clickable--link" (click)="onClientClick(samtalelog.kid)">{{samtalelog.clientId}}</span></td>
                    <td><span class=" clickable--link" (click)="onClientClick(samtalelog.kid)">{{samtalelog.clientName}}</span></td>
                    <td>{{samtalelog.fupName}}</td>
                    <td><span class=" clickable--link" (click)="onTaskClick(samtalelog.lid)">{{samtalelog.tekst}}</span></td>
                    <td class="text-nowrap text-end task__functions">
                        <span class="task__functions--no-hover">
                            {{samtalelog.deadline | date:'dd-MM-yyyy'}}
                        </span>
                        <span class="task__functions--hover">
                            <div class="me-2">
                                <i (click)="onDelete(samtalelog.lid)" class="fa fa-trash text-danger clickable--link"></i>
                            </div>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
        <ng-template #delegatedZero>
            <div class="mb-2">
                Der er ingen uddelegerede opgaver.
            </div>
        </ng-template>
    </div>

</div>
